"use client";

import { ReactNode, useEffect, useRef, useState } from "react";

interface Props {
    children: ReactNode;
}

const ScrollAwareHeader = ({ children }: Props) => {
    const lastScrollY = useRef(0);
    const [isVisible, setIsVisible] = useState(true);

    useEffect(() => {
        lastScrollY.current = window.scrollY;

        const handleScroll = () => {
            const currentScrollY = window.scrollY;

            if (currentScrollY < 80) {
                // Always show near the top of the page
                setIsVisible(true);
            } else if (currentScrollY > lastScrollY.current + 8) {
                // Scrolling down — hide
                setIsVisible(false);
            } else if (currentScrollY < lastScrollY.current - 8) {
                // Scrolling up — show immediately
                setIsVisible(true);
            }

            lastScrollY.current = currentScrollY;
        };

        window.addEventListener("scroll", handleScroll, { passive: true });
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <div
            style={{
                position: 'relative',
                transition: 'transform 300ms ease-out',
                transform: isVisible ? 'translateY(0)' : 'translateY(-100%)',
            }}
        >
            {children}
        </div>
    );
};

export default ScrollAwareHeader;
